// extracted by mini-css-extract-plugin
export var dropdown = "_ff-0";
export var imagePlaceholder = "_ff-2";
export var imageWrapper = "_ff-3";
export var productImage = "_ff-1";
export var truncateContainer = "_ff-4";
export var truncateText = "_ff-5";